const intros = {
  education: [
    {
      introHeader: 'Take a look at our list of educational resources around the world!',
      introCopy: {
        para01: 'Are you looking for a college for women, or a vocational program to learn new skills, or are you interested in finding ways to fund your education? We can help...',
        para03: 'Below you will find some interesting stories and information on what\'s happening for women in education.'
      },
      introCopyMobile: {
        para01: 'Are you looking for a college for women, or a vocational program to learn new skills, or are you interested in finding ways to fund your education? We can help...',
        para03: 'Below you will find some interesting stories and information on what\'s happening for women in education.'
      }
    },
  ],
  health: [
    {
      introHeader: 'Take a look at our list of Health & Wellness resources around the world!',
      introCopy: {
        para01: 'Are you looking for a health center for women in your area, a recreational sports team or fitness center to join, or support for your emotional well-being? We can help...',
        para03: 'Below you will find some interesting stories and information on what’s happening for women in the fields of health and wellness.'
      },
      introCopyMobile: {
        para01: 'Are you looking for a health center for women in your area, a recreational sports team or fitness center to join, or support for your emotional well-being? We can help...',
        para03: 'Below you will find some interesting stories and information on what’s happening for women in the fields of health and wellness.'
      }
    },
  ],
  entertainment: [
    {
      introHeader: 'Take a look at our list of Entertainment resources around the world!',
      introCopy: {
        para01: 'Are you looking for dance, voice or film classes nearby, clubs to join, travel for women, or interesting blogs on fashion, cooking, lifestyle and more? We can help...',
        para03: 'Below you will find some interesting stories and information on what’s happening for women in entertainment.'
      },
      introCopyMobile: {
        para01: 'Are you looking for dance, voice or film classes nearby, clubs to join, travel for women, or interesting blogs on fashion, cooking, lifestyle and more? We can help...',
        para03: 'Below you will find some interesting stories and information on what’s happening for women in entertainment.'
      }
    },
  ],
  money: [
    {
      introHeader: 'Take a look at our list of resources on money around the world!',
      introCopy: {
        para01: 'Are you looking to gain insight on money management, or find someone to help with your financial planning? We can help...',
        para03: 'Below you will find some interesting stories and information on what’s happening for women in the world of money.'
      },
      introCopyMobile: {
        para01: 'Are you looking to gain insight on money management, or find someone to help with your financial planning? We can help...',
        para03: 'Below you will find some interesting stories and information on what’s happening for women in the world of money.'
      }
    },
  ],
  work: [
    {
      introHeader: 'Take a look at our list of resources for women who work around the world!',
      introCopy: {
        para01: 'Are you looking to find a job, advance your career, or join a network specific to your industry?  We can help...',
        para03: 'Below you will find some interesting stories and information on what’s happening for working women'
      },
      introCopyMobile: {
        para01: 'Are you looking to find a job, advance your career, or join a network specific to your industry?  We can help...',
        para03: 'Below you will find some interesting stories and information on what’s happening for working women'
      }
    },
  ],
  entrepreneurs: [
    {
      introHeader: 'Take a look at our list of resources for women entrepreneurs around the world!',
      introCopy: {
        para01: 'Are you looking for investors for your new company, training programs and networks for female entrepreneurs, or advice on growing your business?  We can help...',
        para03: 'Below you will find some interesting stories and information on what\'s happening for women entrepreneurs.'
      },
      introCopyMobile: {
        para01: 'Are you looking for investors for your new company, training programs and networks for female entrepreneurs, or advice on growing your business?  We can help...',
        para03: 'Below you will find some interesting stories and information on what’s happening for women entrepreneurs.'
      }
    },
  ],
  'womens-rights': [
    {
      introHeader: 'Take a look at our list of resources that support women\'s rights around the world!',
      introCopy: {
        para01: 'Are you looking for support and safe spaces to go in times of crisis, programs to advance women\'s right to education, or advocacy groups that are working for gender equality for women and girls? We can help...',
        para03: 'Below you will find some interesting stories and information on what’s happening for women’s rights.'
      },
      introCopyMobile: {
        para01: 'Are you looking for support and safe spaces to go in times of crisis, programs to advance women\'s right to education, or advocacy groups that are working for gender equality for women and girls? We can help...',
        para03: 'Below you will find some interesting stories and information on what’s happening for women\'s rights.'
      }
    },
  ],
  motherhood: [
    {
      introHeader: 'Take a look at our list of resources for mothers around the world!',
      introCopy: {
        para01: 'Are you looking for information on a healthy pregnancy, birth centers, or parenting advice? We can help...',
        para03: 'Below you will find some interesting stories and information on what\'s happening for mothers everywhere.'
      },
      introCopyMobile: {
        para01: 'Are you looking for information on a healthy pregnancy, birth centers, or parenting advice? We can help...',
        para03: 'Below you will find some interesting stories and information on what’s happening for mothers everywhere.'
      }
    },
  ],
  girls: [
    {
      introHeader: 'Take a look at our list of resources for girls around the world!',
      introCopy: {
        para01: 'Are you looking for an after-school program, scholarships for your (or your daughter\'s) education, or support for maintaining a healthy body image? We can help...',
        para03: 'Below you will find some interesting stories and information on what’s happening for girls everywhere.'
      },
      introCopyMobile: {
        para01: 'Are you looking for an after-school program, scholarships for your (or your daughter\'s) education, or support for maintaining a healthy body image? We can help...',
        para03: 'Below you will find some interesting stories and information on what’s happening for girls everywhere.'
      }
    },
  ],
  invest: [
    {
      introHeader: 'Take a look at our list of resources for investors around the world!',
      introCopy: {
        para01: 'Are you looking for an exciting idea to invest in, a crowdfunding sight for women, or a worthy cause to support? We can help...',
        para03: 'Below you will find some interesting stories and information on what’s happening for women investors everywhere.'
      },
      introCopyMobile: {
        para01: 'Are you looking for an exciting idea to invest in, a crowdfunding sight for women, or a worthy cause to support? We can help...',
        para03: 'Below you will find some interesting stories and information on what\'s happening for women investors everywhere.'
      }
    },
  ],
  'global-crises': [
    {
      introHeader: 'Find organizations that respond to humanitarian crises and fight injustices around the world',
      introCopy: {
        para01: 'Are you looking for an exciting idea to invest in, a crowdfunding sight for women, or a worthy cause to support? We can help...',
        para03: 'Below you will find some interesting stories and information on what’s happening for women investors everywhere.'
      },
      introCopyMobile: {
        para01: 'Are you looking for an exciting idea to invest in, a crowdfunding sight for women, or a worthy cause to support? We can help...',
        para03: 'Below you will find some interesting stories and information on what\'s happening for women investors everywhere.'
      }
    },
  ],
};

export default intros;



// WEBPACK FOOTER //
// ./src/misc/categoryLandingIntros.js